import axios from '../axios'

export default class ReportsService {
  

  getReportData(ep, page, rows, sortField, sortOrder, searchText, quickFilters) {
    return new Promise(async function(resolve, reject) {
      try {
        var path = ep + '/' + page + '/' +  rows + '/' +  sortField + '/' +  sortOrder + '/' + searchText
        var response = await axios.post(path, quickFilters)
        // 
        resolve(response)
      } catch (err) {
        
        reject(err)
      }
    })
  }

  dbReportColumns(reportId) {
    return new Promise(async function(resolve, reject) {
      try {
        var path = '/v1/dbReportColumns/' + reportId
        var response = await axios.get(path)
        // 
        resolve(response.data)
      } catch (err) {
        
        reject(err)
      }
    })
  }

  dbreport(reportId) {
    return new Promise(async function(resolve, reject) {
      try {
        var path = '/v1/dbreport/' + reportId
        var response = await axios.get(path)
        // 
        resolve(response.data)
      } catch (err) {
        
        reject(err)
      }
    })
  }

  dbreports() {
    return new Promise(async function(resolve, reject) {
      try {
        var path = '/v1/dbreports'
        var response = await axios.get(path)
        // 
        resolve(response.data)
      } catch (err) {
        
        reject(err)
      }
    })
  }

  getEnquiryRecHistActivities(orderId) {
    return new Promise(async function(resolve, reject) {
      try {
        var path = `/v1/enquiryRecHistActivities/${orderId}`
        var response = await axios.get(path)
        resolve(response.data)
      } catch (err) {
        reject(err)
      }
    })
  }

}